// Ensure ContentAIHelper is defined as a functional component
import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTemplate } from "../../../redux/slices/templateSlice";
import { setPlaylist } from "../../../redux/slices/playlistSlice";
import { setEventcustomisation } from "../../../redux/slices/eventcustomisationsSlice";
import { setResolutionsList } from "../../../redux/slices/resolutionSlice";
import { setLocation } from "../../../redux/slices/locationSlice";
import { setScreenuser } from "../../../redux/slices/screenusersSlice";

export function ContentAIHelper() {
  const dispatch = useDispatch();
  const selectedOption = useSelector((state) => state?.curremms?.curremms?.id);
  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state?.header);

  const emmsheaders = useSelector((state) => state?.emmsheader);

  useEffect(() => {
    const requestBody1 = {
      path: "template",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const requestBody2 = {
      path: "playlist",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const requestBody3 = {
      path: "list/eventcustomisations",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const requestBody4 = {
      path: "resolution",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .all([
        axios.post(api + `/emms/piggyback`, requestBody1, headers),
        axios.post(api + `/emms/piggyback`, requestBody2, headers),
        axios.post(api + `/emms/piggyback`, requestBody3, headers),
        axios.post(api + `/emms/piggyback`, requestBody4, headers),
      ])
      .then(
        axios.spread((response1, response2, response3, response4) => {
          dispatch(setTemplate(response1.data));
          dispatch(setPlaylist(response2.data));
          dispatch(setEventcustomisation(response3.data));
          dispatch(setResolutionsList(response4.data));
        })
      )
      .catch((error) => {
        console.error(error);
      });
  }, [selectedOption]); // Re-run the effect when selectedOption or emmsheaders changes

  return null; // This component doesn't need to render anything
}
